import A from 'const/actionTypes'
import initialState from 'store/initialState'

export default (currentState = initialState.powerRankingCount, action) => {
  let updatedState = currentState

  switch (action.type) {
    case A.CLEAR_POWER_RANKING_COUNT:
      updatedState = 0
      break
    case A.SET_POWER_RANKING_COUNT:
      updatedState = action.powerRankingCount
      break
  }

  return updatedState
}



// WEBPACK FOOTER //
// ./src/app/reducers/powerRankingCount.js